// Ruta de respaldo para cualquier URL que no case con ninguna otra.
//
// Sin esto, React Router no pintaba nada y el visitante veía una página EN
// BLANCO: un link viejo, una dirección mal copiada o un producto retirado
// acababan en la nada. nginx sirve el index.html de la home para todo lo que no
// existe, así que el 404 real no se puede emitir desde aquí; lo que sí se puede
// es no dejar a nadie mirando el vacío, y pedirle a Google que no indexe esto.

import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import Footer from '../components/sections/Footer';
import Seo from '../components/Seo';
import { businessInfo } from '../mock';

const NoEncontrado = () => (
  <div className="min-h-screen bg-cream flex flex-col">
    <Seo
      title="Página no encontrada | Brazolovers"
      description="Esta página no existe o se movió. Mira el menú completo de Brazolovers."
      noindex
    />
    <SiteHeader />

    <main className="flex-1 container mx-auto px-4 md:px-6 py-16 text-center">
      <h1 className="text-2xl md:text-3xl font-bold" style={{ color: '#2c1810' }}>
        No encontramos esta página
      </h1>
      <p className="mt-3 mx-auto" style={{ color: '#8a6a5e', maxWidth: '30rem', lineHeight: 1.7 }}>
        Puede que el enlace esté incompleto, o que lo que buscabas ya no esté en
        el menú. Lo de siempre sigue aquí.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/menu"
          className="px-6 py-3 rounded-2xl font-semibold"
          style={{ background: '#2c1810', color: 'white', textDecoration: 'none' }}
        >
          Ver el menú
        </Link>
        <Link
          to="/"
          className="px-6 py-3 rounded-2xl font-semibold"
          style={{ border: '1.5px solid #e8e0d8', color: '#2c1810', textDecoration: 'none' }}
        >
          Ir al inicio
        </Link>
      </div>
    </main>

    <Footer businessInfo={businessInfo} />
  </div>
);

export default NoEncontrado;
